export enum ContentHeaderTab {
  downloadUpload = "Download & Upload",
  editAdd = "Edit & Add"
}
